import PropTypes from 'prop-types';

export const graphicsItemType = PropTypes.shape({
  label: PropTypes.string.isRequired,
  value: PropTypes.shape({
    balance: PropTypes.number,
    initialBalance: PropTypes.number,
    infinity: PropTypes.bool,
    unity: PropTypes.string,
  }).isRequired,
});

export const bundleType = PropTypes.shape({
  activationDate: PropTypes.string,
  balance: PropTypes.string,
  code: PropTypes.string,
  consumption: PropTypes.string,
  expirationDate: PropTypes.string,
  initialBalance: PropTypes.string,
  name: PropTypes.string,
  validity: PropTypes.shape({
    unity: PropTypes.string,
    value: PropTypes.number,
  }),
});

export const balanceDataType = PropTypes.shape({
  balance: PropTypes.shape({
    total: PropTypes.number,
  }),
  graphics: PropTypes.shape({
    data: graphicsItemType,
    minutes: graphicsItemType,
    sms: graphicsItemType,
  }).isRequired,
  otherData: PropTypes.arrayOf(bundleType),
  otherMinutes: PropTypes.arrayOf(bundleType),
  promotionalData: PropTypes.arrayOf(bundleType),
  promotionalMinutes: PropTypes.arrayOf(bundleType),
});

const promotionalData = PropTypes.shape({
  name: PropTypes.string,
  expirationDate: PropTypes.string,
});

export const promotionalDataType = PropTypes.arrayOf(promotionalData);
